import type { jsPDF } from "jspdf";
import { Box } from "../layout/box";

export abstract class BaseElement {
	kind!: string;
	children: BaseElement[] = [];
	newPage = false;
	box: Box;
	id: string;
	colSpan = 1; // Hack for grid containers

	constructor(box: Box, id: string) {
		this.box = box;
		this.id = id;
	}

	addElement(element: BaseElement) {
		this.children.push(element);
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	async calculate(_: jsPDF) {
		return;
	}

	async draw(pdfDocument: jsPDF) {
		for (const child of this.children) {
			await child.draw(pdfDocument);
		}
	}

	async debugRect(pdfDocument: jsPDF) {
		const box = this.box.getBoundingBox();
		pdfDocument.setDrawColor(0, 0, 0);
		pdfDocument.rect(box.x, box.y, box.outerWidth, box.outerHeight, "S");
	}
}
